<template>
  <div>
    <activity-flow-card
      card_title="Equipos"
      extra-class="bg-green"
      :data="reportData"
      :map-data="{ title: 'Title', qty: 'Qty', status: 'status' }"
      :loading="loading"
      @click-item-qty="handleClickLink"
    >
    </activity-flow-card>

    <rabbey-base-drawer :drawer.sync="drawer" size="80%" :title="title">
      <CardStatDrawerHeader
        :itemQuantity="itemQuantity"
        :totalAmount="totalAmount"
        :totalInvoice="totalInvoice"
        :Title="title"
        :status="status"
      />

      <rabbey-toolbox :filterables="true" @filter-search="search = $event" />
      <rabbey-table3
        :data="items"
        :search="search"
        :columns="columns"
        :actions="actions"
        :stripe="true"
        @rtable-push-action="handleCommand"
      ></rabbey-table3>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import axios from "axios";
import ActivityFlowCard from "@/components/activity_flow/ActivityFlowCard.vue";
import {
  GPSLastConnectionColumns,
  GPSLastConnectionActions
} from "@/columns/GPSLasConnectionsColumns";
import { helperGetColumsItems } from "./utils.js";
import CardStatDrawerHeader from "./CardStatDrawerHeader.vue";

export default {
  name: "EquipmentStat",
  props: {
    employee: {
      type: [String, Number]
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActivityFlowCard,
    CardStatDrawerHeader
  },
  created() {
    //this.getReportData();
    this.GetOfflineGPSs();
  },
  data() {
    return {
      reportData: [],
      loading: false,
      title: "",
      dialogVisible: false,
      drawer: false,
      search: "",
      columns: [],
      actions: GPSLastConnectionActions(),
      items: [],
      itemQuantity: 0,
      totalAmount: 0,
      totalInvoice: 0,
      request: null, // cancelation token
      mapColumns: {
        AllGPSs: GPSLastConnectionColumns,
        ActiveGPSs: GPSLastConnectionColumns,
        LastConnectionLess48Hours: GPSLastConnectionColumns,
        LastConnectionMore7: GPSLastConnectionColumns,
        LastConnectionMore15: GPSLastConnectionColumns,
        LastConnectionMore30: GPSLastConnectionColumns,
        InactiveGPSs: GPSLastConnectionColumns,
        GPSinWorkshop: GPSLastConnectionColumns,
        GPStransferred: GPSLastConnectionColumns,
        KPIGPSs: GPSLastConnectionColumns
      },
      status: ""
    };
  },
  methods: {
    /*
    getReportData() {
      if (this.request) {
        this.request.cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetEquipment", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            CompanyCode: this.currentCompany,
            UserName: this.currentUser.UserName,
            EmployeeId: this.employee,
            PersonCode: this.currentUser.PersonCode
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          this.loading = false;
        })
        .catch((error) => console.error(error));
    },
    */
    GetOfflineGPSs: async function () {
      this.reportData = [];
      let trackersCount = await this.$store.dispatch("navixy/getTotalGps");
      trackersCount;
      let NavUsersCount = await this.$store.dispatch("navixy/getTotalUsers");
      NavUsersCount;
      this.loading = true;
      let trackers = this.$store.getters["navixy/getTrackers"];
      let NavUsers = this.$store.getters["navixy/getUserList"];

      const trackersIdsInWorkshop =
        await this.retriveGPSinWorkshopOrTransferred();

      const trackersInWorkshop = trackers.filter((t) =>
        trackersIdsInWorkshop.some(
          (w) => w.trackerId === t.id && w.status === "workshop"
        )
      );
      const trackersTransferred = trackers.filter((t) =>
        trackersIdsInWorkshop.some(
          (w) => w.trackerId === t.id && w.status === "transferred"
        )
      );

      let activeTrackers = trackers.filter(
        (t) => t.source.connection_status !== "offline"
      );

      let OfflineTrackers = trackers.filter(
        (t) =>
          t.source.connection_status === "offline" &&
          !trackersIdsInWorkshop.some(
            (w) =>
              w.trackerId === t.id &&
              (w.status === "workshop" || w.status === "transferred")
          )
      );

      // OfflineTrackers.filter(t =>  !trackersIdsInWorkshop.some(w => w.trackerId === t.id && (w.status === 'workshop' || w.status === 'transferred')))

      let customersWithContact;

      if (this.request) {
        this.request.cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      await this.$http
        .get("/api/customers/GetCustomersWithContacts", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            Page: 1,
            Limit: 1000000,
            CompanyId: this.currentCompany,
            SalesPersonCode: null,
            Name: null,
            CustomerService: null,
            Contract: null,
            AccountReceivable: null,
            clasificaction: null,
            ClientType: null
          }
        })
        .then((response) => {
          customersWithContact = response.data.Items;
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.loading = false;
        });

      let actualDate = new Date();

      trackersInWorkshop.forEach((ot) => {
        ot.user = NavUsers.filter((nu) => nu.id === ot.user_id)[0];
        ot.client = customersWithContact.filter(
          (cust) => cust.ClientCode === ot.user.post_region
        )[0];
        ot.daysOffline = Math.round(
          Math.abs(
            new Date(ot.last_connection).getTime() - actualDate.getTime()
          ) /
            (1000 * 3600 * 24)
        );
        ot.status = "workshop";
      });

      trackersTransferred.forEach((ot) => {
        ot.user = NavUsers.filter((nu) => nu.id === ot.user_id)[0];
        ot.client = customersWithContact.filter(
          (cust) => cust.ClientCode === ot.user.post_region
        )[0];
        ot.daysOffline = Math.round(
          Math.abs(
            new Date(ot.last_connection).getTime() - actualDate.getTime()
          ) /
            (1000 * 3600 * 24)
        );
        ot.status = "sold";
      });

      OfflineTrackers.forEach((ot) => {
        ot.user = NavUsers.filter((nu) => nu.id === ot.user_id)[0];
        ot.client = customersWithContact.filter(
          (cust) => cust.ClientCode === ot.user.post_region
        )[0];
        ot.daysOffline = Math.round(
          Math.abs(
            new Date(ot.last_connection).getTime() - actualDate.getTime()
          ) /
            (1000 * 3600 * 24)
        );
        ot.status = "offline";
      });

      activeTrackers.forEach((ot) => {
        ot.user = NavUsers.filter((nu) => nu.id === ot.user_id)[0];
        ot.client = customersWithContact.filter(
          (cust) => cust.ClientCode === ot.user.post_region
        )[0];
        ot.daysOffline = Math.round(
          Math.abs(
            new Date(ot.last_connection).getTime() - actualDate.getTime()
          ) /
            (1000 * 3600 * 24)
        );
      });

      trackers.forEach((ot) => {
        ot.user = NavUsers.filter((nu) => nu.id === ot.user_id)[0];
        ot.client = customersWithContact.filter(
          (cust) => cust.ClientCode === ot.user.post_region
        )[0];
        ot.daysOffline = Math.round(
          Math.abs(
            new Date(ot.last_connection).getTime() - actualDate.getTime()
          ) /
            (1000 * 3600 * 24)
        );
      });

      let Titkes = [
        { title: "Total GPS", status: "all" },
        { title: "Total GPS Activos", status: "active" },
        { title: "Total GPS Inactivos", status: "inactive" },
        {
          title: "GPS Fuera de línea de 2 a 6 días",
          myq: 2,
          mnq: 6,
          status: "offline"
        },
        {
          title: "GPS Fuera de línea de 7 a 14 días",
          myq: 6,
          mnq: 14,
          status: "offline"
        },
        {
          title: "GPS Fuera de línea de 15 a 29 días",
          myq: 14,
          mnq: 29,
          status: "offline"
        },
        {
          title: "GPS Fuera de línea de 30 a más días",
          myq: 29,
          mnq: null,
          status: "offline"
        },
        { title: "GPS en el taller", status: "workshop" },
        { title: "GPS traspasados, Recuperación", status: "sold" },
        { title: "KPI GPS inactivos", status: "kpi" }
      ];

      Titkes.forEach((t) => {
        if (t.status === "all") {
          this.reportData.push({
            Title: t.title,
            Qty: trackers.length,
            AllGPSs: trackers
          });
        } else if (t.status === "active") {
          this.reportData.push({
            Title: t.title,
            Qty: activeTrackers.length,
            ActiveGPSs: activeTrackers
          });
        } else if (t.status === "inactive") {
          this.reportData.push({
            Title: t.title,
            Qty: OfflineTrackers.length,
            InactiveGPSs: OfflineTrackers
          });
        } else if (t.status === "offline") {
          this.reportData.push({
            Title: t.title,
            Qty: this.FilteringByDaysOffline(OfflineTrackers, t.myq, t.mnq)
              .length,
            LastConnectionLess48Hours: this.FilteringByDaysOffline(
              OfflineTrackers,
              t.myq,
              t.mnq
            ),
            LastConnectionMore7: this.FilteringByDaysOffline(
              OfflineTrackers,
              t.myq,
              t.mnq
            ),
            LastConnectionMore15: this.FilteringByDaysOffline(
              OfflineTrackers,
              t.myq,
              t.mnq
            ),
            LastConnectionMore30: this.FilteringByDaysOffline(
              OfflineTrackers,
              t.myq,
              t.mnq
            )
          });
        } else if (t.status === "workshop") {
          this.reportData.push({
            Title: t.title,
            Qty: trackersInWorkshop.length,
            GPSinWorkshop: trackersInWorkshop
          });
        } else if (t.status === "sold") {
          this.reportData.push({
            Title: t.title,
            Qty: trackersTransferred.length,
            GPStransferred: trackersTransferred
          });
        } else if (t.status === "kpi") {
          this.reportData.push({
            Title: t.title,
            Qty: ((OfflineTrackers.length / trackers.length) * 100)
              .toFixed(2)
              .toString(),
            KPIGPSs: OfflineTrackers,
            status: t.status
          });
        }
      });
    },

    FilteringByDaysOffline(OfflineTrackers, mayorQue, menorIgualQue) {
      let FilteredOfflineTrackers = [];
      if (menorIgualQue !== null) {
        FilteredOfflineTrackers = OfflineTrackers.filter(
          (offtrack) =>
            offtrack.daysOffline > mayorQue &&
            offtrack.daysOffline <= menorIgualQue
        );
      } else {
        FilteredOfflineTrackers = OfflineTrackers.filter(
          (offtrack) => offtrack.daysOffline > mayorQue
        );
      }

      return FilteredOfflineTrackers;
    },
    handleClickLink(props) {
      const report = this.reportData.find((f) => f.Title === props.title);
      const { items, columns } = helperGetColumsItems(report, this.mapColumns);
      this.items = items;
      this.columns = columns;
      this.title = props.title;
      this.drawer = true;

      this.totalAmount = props.qty; // Gets total items to display it on the header of the drawer
      this.itemQuantity = this.items.length; // Gets total items to display it on the header of the drawer
      this.totalInvoice = this.items.length;
      this.status = props.status;
    },
    async handleCommand(action) {
      switch (action.command) {
        case "workshop_move": {
          await this.moveGPSstatus(action.row.id, "workshop");
          this.items = this.items.filter((i) => i.id !== action.row.id);
          break;
        }
        case "transferred": {
          await this.moveGPSstatus(action.row.id, "transferred");
          this.items = this.items.filter((i) => i.id !== action.row.id);
          break;
        }
        case "out_of_workshop": {
          await this.moveGPSOut(action.row.id);
          this.items = this.items.filter((i) => i.id !== action.row.id);
          break;
        }
        case "retrieve": {
          await this.moveGPSOut(action.row.id);
          this.items = this.items.filter((i) => i.id !== action.row.id);
          break;
        }
      }
      this.GetOfflineGPSs();
    },
    async moveGPSstatus(trackerId, status) {
      const body = {
        trackerId: trackerId,
        status: status
      };

      await this.$http
        .post("/api/navixy/MoveGps", body)
        .then((resp) => {
          if (resp.data) {
            this.$message.success("GPS Movido correctamente");
          } else {
            this.$message.error("Error al mover GPS");
          }
        })
        .catch((err) => {
          console.error("Error al mover GPS: ", err);
          this.$message("ocurrio un error, verificar consola");
        });
    },
    async moveGPSOut(trackerId) {
      const body = {
        trackerId: trackerId
      };

      await this.$http
        .put("/api/navixy/MovingOutGps", body)
        .then((resp) => {
          if (resp.data) {
            this.$message.success("GPS Movido correctamente");
          } else {
            this.$message.error("Error al mover GPS");
          }
        })
        .catch((err) => {
          console.error("Error al mover GPS: ", err);
          this.$message("ocurrio un error, verificar consola");
        });
    },
    async retriveGPSinWorkshopOrTransferred() {
      const result = await this.$http
        .get("/api/navixy/RetriveGPSInWorkshopOrTransferred")
        .then((resp) => {
          return resp.data;
        })
        .catch((err) => {
          console.error(
            "Ocurrio un error al traer los GPS del taller o transferidos: ",
            err
          );
        });

      return result;
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    },
    employee() {
      this.getReportData();
    }
  }
};
</script>

<style></style>
